var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Fill Outline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dfd9d3",
    d: "M16 48h32v13H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#56a8c6",
    d: "M48 48V10l-32 2v36h32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80c5d4",
    d: "M15 20h33v2H15zM15 29h33v2H15zM15 38h33v2H15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80c5d4",
    d: "M39 10h2v38h-2zM31 10h2v38h-2zM23 10h2v38h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 61a3 3 0 1 1 1-6 3 3 0 0 1 4-2 3 3 0 1 1 6 2 3 3 0 0 1-1 6z",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#196aaf",
    d: "M17 8V3h30v3L17 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfd9d3",
    d: "M7 14h2v22H7zM51 25h2v22h-2zM51 21h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7c2bc",
    d: "M50 10V6L12 8v53h4V12l34-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 61h-2V8a1 1 0 0 1 1-1l41-2v2L13 9z",
    fill: "#dfd9d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 61a3 3 0 1 0-1-6 3 3 0 0 0-4-2 3 3 0 1 0-6 2 3 3 0 0 0 1 6z",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#56a8c6",
    d: "M25 52h7v9h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80c5d4",
    d: "M32 52h7v9h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfd9d3",
    d: "M29 56h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#196aaf",
    d: "M22 51h20v2H22z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.dcd113713353ca58a72538a3ce18e763.svg";
export { ForwardRef as ReactComponent };